import { useContext } from "react";
import { Context } from "../../../../context/Context";
import { Button, Input } from "../../../ui";

// The Section model's editable fields (order is managed by reordering).
// Shared by this modal and the top-level Section actions.
export function SectionFields({ data, onChange }) {
  const { lang } = useContext(Context);
  const isArabic = lang === "ar";
  const set = (key, value) => onChange({ ...data, name: { ...data.name, [key]: value } });
  return (
    <>
      <Input type="text" placeholder={isArabic ? "اسم القسم عربي" : "Arabic section name"} aria-label={isArabic ? "اسم القسم عربي" : "Arabic section name"} value={data.name.ar} onChange={(e) => set("ar", e.target.value)} />
      <Input type="text" placeholder={isArabic ? "اسم القسم انجليزي" : "English section name"} aria-label={isArabic ? "اسم القسم انجليزي" : "English section name"} value={data.name.en} onChange={(e) => set("en", e.target.value)} />
    </>
  );
}

// Used for both "new section" and "rename section".
export default function AddSectionModal({ newSectionData, setNewSectionData, handleAddSection, onCancel, mode = "add", busy = false, error = "" }) {
  const { lang } = useContext(Context);
  const isArabic = lang === "ar";
  return (
    <div className="food-modal-overlay">
      <div className="food-modal" role="dialog" aria-modal="true">
        <h3>{mode === "rename" ? (isArabic ? "تعديل اسم القسم" : "Rename section") : isArabic ? "إضافة قسم جديد" : "New section"}</h3>
        <SectionFields data={newSectionData} onChange={setNewSectionData} />
        {error && (
          <p className="menu-error" role="alert">
            {error}
          </p>
        )}
        <div className="food-modal-actions">
          <Button type="button" variant="primary" appearance="filled" disabled={busy} onClick={handleAddSection}>
            {isArabic ? "حفظ" : "Save"}
          </Button>
          <Button type="button" variant="warning" appearance="soft" disabled={busy} onClick={onCancel}>
            {isArabic ? "إلغاء" : "Cancel"}
          </Button>
        </div>
      </div>
    </div>
  );
}
